export function disableButton(button) {
  button.classList.add('disabled');
}

export function enableButton(button) {
  button.classList.remove('disabled');
}
